import { render, staticRenderFns } from "./Cust.vue?vue&type=template&id=495d71ee"
import script from "./Cust.vue?vue&type=script&lang=js"
export * from "./Cust.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports